export default __webpack_public_path__ + "static/media/AlienRadio.ad48ac5e.mp3";